// extracted by mini-css-extract-plugin
export default {"footerWrapper":"style_footerWrapper__b0RhU","count":"style_count__C9EQL","tooltipWrapper":"style_tooltipWrapper__Yo82P"};